<div class="modal-table">
  <table class="w-100 my-5">
    <thead>
    <tr>
      <th>{{'wizard.invalid-dialog.row' | translate}}</th>
      <th>{{'wizard.invalid-dialog.reason' | translate}}</th>
    </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of invalidDataList">
        <td><strong>{{2+row.line}}</strong></td>
        <td>{{row.error | translate}}</td>
      </tr>
    </tbody>
  </table>
  <button class="primary-btn" (click)="close()">{{'wizard.invalid-dialog.btn-close' | translate}}</button>
</div>
